import { Link } from "react-router-dom";

function Footer() {
  const currentYear = new Date().getFullYear();
  const openTrackingPreferences = () => {
    window.dispatchEvent(new CustomEvent("proshare:open-tracking-consent"));
  };

  return (
    <footer className="mt-14 border-t border-slate-200 bg-gradient-to-b from-white to-slate-50/70">
      <div className="mx-auto flex w-full max-w-[1400px] flex-col gap-7 px-4 py-10 md:px-6">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div className="space-y-2">
            <p className="m-0 text-xs font-semibold uppercase tracking-[0.22em] text-sky-700">
              ProShare Marketplace
            </p>
            <p className="m-0 text-lg font-semibold text-slate-900">ProShare</p>
            <p className="m-0 max-w-xl text-sm leading-6 text-slate-500">
              Marketplace resources for speech and language professionals.
            </p>
          </div>
          <p className="m-0 text-sm text-slate-500 md:text-right">
            ProShare &copy; {currentYear} All Rights Reserved.
          </p>
        </div>

        <nav className="flex flex-wrap items-center gap-2.5 md:gap-3">
          <Link className="rounded-full border border-slate-200 bg-white px-3.5 py-2 text-sm font-medium text-slate-700 no-underline transition hover:-translate-y-0.5 hover:bg-slate-50" to="/help">
            Help & FAQ
          </Link>
          <Link className="rounded-full border border-slate-200 bg-white px-3.5 py-2 text-sm font-medium text-slate-700 no-underline transition hover:-translate-y-0.5 hover:bg-slate-50" to="/privacy-policy">
            Privacy Policy
          </Link>
          <Link className="rounded-full border border-slate-200 bg-white px-3.5 py-2 text-sm font-medium text-slate-700 no-underline transition hover:-translate-y-0.5 hover:bg-slate-50" to="/terms">
            Terms & Conditions
          </Link>
          <Link className="rounded-full border border-slate-200 bg-white px-3.5 py-2 text-sm font-medium text-slate-700 no-underline transition hover:-translate-y-0.5 hover:bg-slate-50" to="/security">
            Security
          </Link>
          <Link className="rounded-full border border-slate-200 bg-white px-3.5 py-2 text-sm font-medium text-slate-700 no-underline transition hover:-translate-y-0.5 hover:bg-slate-50" to="/who-we-are">
            Who We Are
          </Link>
          <button
            type="button"
            className="rounded-full border border-slate-200 bg-white px-3.5 py-2 text-sm font-medium text-slate-700 transition hover:-translate-y-0.5 hover:bg-slate-50"
            onClick={openTrackingPreferences}
          >
            Tracking Preferences
          </button>
        </nav>
      </div>
    </footer>
  );
}

export default Footer;
